import React from 'react';

import Box from '../../Box';
import Flex from '../../Flex';
import Text from '../../Text';

const BorderBox = ({ label, children, ...props }) => (
  <Flex flexDirection="column" {...props}>
    <Text mx="0.5em" mb="0.5em">{label}</Text>
    <Box flex={1} border="1px solid" borderColor="gray" px="0.5em">
      {children}
    </Box>
  </Flex>
);

export default BorderBox;
